export const auctionEntryKind: Record<string, string> = {
  open: 'Aberto',
  closed: 'Fechado',
}
